import React from 'react';
import FormStyle1 from '../Form/FormStyle1';
import ImageGrid from '../ImageGrid/ImageGrid';
import SpainHeaderComp from '../Header/SpainHeaderComp'
import Section from '../Section'
import GuaranteesSpainText from '../GuaranteesSpainText';

const GestlifeGuaranteeLayout = () => {
  return (
    <>
    <SpainHeaderComp logoSrc="/images/logotipo_blanco.svg"/>
 <Section
        style={{
          background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '50px ',
          minHeight: '150px', // Add this line to ensure minimum height
        }}
/>
 {/* <AssistedReproductionSection />  */}
<GuaranteesSpainText />

    </>

  )
};

export default GestlifeGuaranteeLayout;

// --- Estilos para la versión de escritorio ---
const styles = {
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontFamily: 'Arial, sans-serif', 
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr', // Por defecto, una columna para móviles
    gap: '4rem', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    // La media query para desktop se simula con JS debajo
    // Idealmente, esto iría en CSS externo o con una librería CSS-in-JS.
    '@media (min-width: 1024px)': { 
      gridTemplateColumns: '2fr 1fr', 
    },
  },
  mainContent: {
    marginBottom: '2rem', // Mantener espacio para móviles/tablets
    '@media (min-width: 1024px)': {
      marginBottom: '0', // Eliminar el margen si hay dos columnas
    },
  },
  mainHeading: {
    fontSize: '2.8rem', 
    fontWeight: 'bold',
    color: '#ec4899', 
    lineHeight: '1.2',
    marginBottom: '1.5rem', 
  },
  subHeading: {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#f472b6', 
    marginTop: '2.5rem', 
    marginBottom: '1.5rem', 
    borderBottom: '2px solid #f9a8d4', 
    paddingBottom: '0.5rem',
  },
  subHeadingMinor: { 
    fontSize: '1.3rem', 
    fontWeight: '600', 
    color: '#f472b6', 
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  textBlock: {
    color: '#4b5563',
    lineHeight: '1.7', 
    fontSize: '1.05rem', 
    marginTop: '1.5rem',
  },
  paragraph: {
    marginBottom: '1rem', 
  },
  highlightedParagraph: {
    fontWeight: '700', 
    color: '#1f2937', 
    textDecoration: 'underline',
    textDecorationColor: '#f9a8d4', 
    marginBottom: '1.2rem', 
    fontSize: '1.1rem', 
  },
  formColumn: {
    // Ya no necesita position: 'relative' si el formulario no es sticky
    // El formulario FormStyle1 controlará sus propios estilos internos
  },
  // Eliminamos el objeto stickyForm, ya no es necesario
};
